import { Routes } from '@angular/router';
import { RouteAccessGuard } from '@app/core/guards/route-access.guard';
import { FortinetMetricsComponent } from './fortinet-metrics.component';
import { Authority } from '@app/shared/utils/enums';

export const fortinetMetricsRoutes: Routes = [
    {
        path: 'fortinet-metrics',
        children: [
            {
                path: '',
                component: FortinetMetricsComponent,
                data: {
                    authorities: [Authority.ADMIN, Authority.RESTAURANT_VIEW, Authority.HELP_1]
                }
                //,canActivate: [RouteAccessGuard]
            }
        ]
    }
]